/**
 * Logica per la visualizzazione della lista delle notifiche
 */
export class NotificationsLogic {
  /**
   * Ritorna vero se la configurazione prevede di mostrare la lista delle notifiche.
   */
  static showListPage() {
    return process.env.SHOW_NOTIFICATIONS_PAGE === 'true';
  }
}
